import { Icon } from "@iconify/react";

const CardIcon = (props) => {
	return (
		<div className="card skill-box">
			<div className="card-body">
				<Icon icon={props.icon} className="skill-icon" style={{ color: props.colorIcon }} />
				<h5 className="card-title">{props.name}</h5>
			</div>
		</div>
	);
};

export default CardIcon;
